import p2 from 'p2';
import { Sprite } from 'pixi.js';

import { Game } from '../Game';
import { PhysicsCollisionGroup, PhysicsShapeType, PhysicsUtils } from '../physics';
import { PhysicsComponent } from '../physics/PhysicsComponent';
import { BaseEntity } from './BaseEntity';

export interface TutorialAreaEntityParams
{
    type: string,
    x: number,
    y: number,
    w: number,
    h: number,
    r: number,
    props: {
        name: string
    }
}

export class TutorialAreaEntity extends BaseEntity
{
    public sprite!: Sprite;
    public params!: TutorialAreaEntityParams;
    public physics: PhysicsComponent;
    public reached = false;

    constructor()
    {
        super();
        this.physics = this.addComponent(PhysicsComponent as any) as PhysicsComponent;
        this.physics.culling = true;
    }

    public build(params: TutorialAreaEntityParams): void
    {
        this.physics.clearParts();
        this.params = params;

        const body = PhysicsUtils.createBody({
            x: this.params.x,
            y: this.params.y,
            angle: this.params.r,
            mass: 0,
        }, {
            type: PhysicsShapeType.BOX,
            width: this.params.w,
            height: this.params.h,
            sensor: true,
            group: PhysicsCollisionGroup.OBJECT,
            mask: PhysicsCollisionGroup.VEHICLE,
        });

        this.physics.addParts(body);
        this.name = this.params.props.name;
    }

    public levelReset(): void
    {
        this.reached = false;
    }

    protected onBeginContact(other: p2.Body): void
    {
        if (this.reached) return;

        const game = this.scene as Game;

        if (game.race.running && game.vehicle.assembled && other.physicsComponent?.entity === game.vehicle.character)
        {
            this.reached = true;
            game.tutorial.tutorialStep(this.params.props.name);
        }
    }
}

export class TutorialAreaFactory
{
    public static match(data: Record<string, any>): boolean
    {
        return data.type === 'TriggerEntity' && data?.props?.name && data?.props?.name.startsWith('tutorial-');
    }

    public static create(game: Game, data: Record<string, any>): void
    {
        const entity = game.pool.get(TutorialAreaEntity) as TutorialAreaEntity;

        entity.build(data as TutorialAreaEntityParams);

        game.level.addEntity(entity);
    }
}

